import React from 'react'
import {
  ImageCircle,
  NotificationRowProps,
  NotificationRowShell,
  UserAvatarCircle
} from './notification-row-shell'

/**
 * Fallback row for types without a dedicated component (e.g. action_potential_credited,
 * geo_context_alert). Picks up a user avatar / action link from common metadata keys
 * when present.
 */
const GenericNotificationRow = (props: NotificationRowProps) => {
  const meta = props.notification.metadata || {}
  const userAvatar = meta.triggering_user_avatar || meta.user_avatar
  const actionSlug = meta.action_slug || meta.triggering_action_slug
  const actionImage = meta.action_image || meta.triggering_action_image

  return (
    <NotificationRowShell
      {...props}
      avatar={
        userAvatar ? <UserAvatarCircle src={userAvatar} /> : <ImageCircle src={actionImage} />
      }
      destination={actionSlug ? `/action/${actionSlug}` : undefined}
      highlights={[
        meta.triggering_user_name || meta.user_name,
        meta.action_name || meta.triggering_action_name
      ]}
    />
  )
}

export default GenericNotificationRow
